module.exports = __webpack_public_path__ + "static/media/039.5aea246a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/039.jpg
// module id = 385
// module chunks = 0